module.exports = __webpack_public_path__ + "img/icon_decoration5.d4708372.png";